/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  GetMcpServerActivityPayload,
  GetMcpServerActivityPayload$Outbound,
  GetMcpServerActivityPayload$outboundSchema,
} from "../components/getmcpserveractivitypayload.js";

export type GetMcpServerActivitySecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetMcpServerActivitySecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetMcpServerActivitySecurity = {
  option1?: GetMcpServerActivitySecurityOption1 | undefined;
  option2?: GetMcpServerActivitySecurityOption2 | undefined;
};

export type GetMcpServerActivityRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  getMcpServerActivityPayload: GetMcpServerActivityPayload;
};

/** @internal */
export type GetMcpServerActivitySecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetMcpServerActivitySecurityOption1$outboundSchema: z.ZodMiniType<
  GetMcpServerActivitySecurityOption1$Outbound,
  GetMcpServerActivitySecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getMcpServerActivitySecurityOption1ToJSON(
  getMcpServerActivitySecurityOption1: GetMcpServerActivitySecurityOption1,
): string {
  return JSON.stringify(
    GetMcpServerActivitySecurityOption1$outboundSchema.parse(
      getMcpServerActivitySecurityOption1,
    ),
  );
}

/** @internal */
export type GetMcpServerActivitySecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetMcpServerActivitySecurityOption2$outboundSchema: z.ZodMiniType<
  GetMcpServerActivitySecurityOption2$Outbound,
  GetMcpServerActivitySecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getMcpServerActivitySecurityOption2ToJSON(
  getMcpServerActivitySecurityOption2: GetMcpServerActivitySecurityOption2,
): string {
  return JSON.stringify(
    GetMcpServerActivitySecurityOption2$outboundSchema.parse(
      getMcpServerActivitySecurityOption2,
    ),
  );
}

/** @internal */
export type GetMcpServerActivitySecurity$Outbound = {
  Option1?: GetMcpServerActivitySecurityOption1$Outbound | undefined;
  Option2?: GetMcpServerActivitySecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetMcpServerActivitySecurity$outboundSchema: z.ZodMiniType<
  GetMcpServerActivitySecurity$Outbound,
  GetMcpServerActivitySecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetMcpServerActivitySecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetMcpServerActivitySecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getMcpServerActivitySecurityToJSON(
  getMcpServerActivitySecurity: GetMcpServerActivitySecurity,
): string {
  return JSON.stringify(
    GetMcpServerActivitySecurity$outboundSchema.parse(
      getMcpServerActivitySecurity,
    ),
  );
}

/** @internal */
export type GetMcpServerActivityRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  GetMcpServerActivityPayload: GetMcpServerActivityPayload$Outbound;
};

/** @internal */
export const GetMcpServerActivityRequest$outboundSchema: z.ZodMiniType<
  GetMcpServerActivityRequest$Outbound,
  GetMcpServerActivityRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    getMcpServerActivityPayload: GetMcpServerActivityPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      getMcpServerActivityPayload: "GetMcpServerActivityPayload",
    });
  }),
);

export function getMcpServerActivityRequestToJSON(
  getMcpServerActivityRequest: GetMcpServerActivityRequest,
): string {
  return JSON.stringify(
    GetMcpServerActivityRequest$outboundSchema.parse(
      getMcpServerActivityRequest,
    ),
  );
}
